import { FormattedMessage } from "react-intl";

const CustomizableApprovalProcesses = () => {
    return (
        <div>
            <p>
                <FormattedMessage
                    id="JiraSoftwarePricingPageTeam24.features.customizableApprovalProcesses.content.body"
                    defaultMessage="Add approval steps to your workflows to get required signoffs."
                />
            </p>
        </div>
    );
};

export default CustomizableApprovalProcesses;
